import { useSelector } from "react-redux";
import "./Checkbox.scss";
import { Checkbox as AntdCheckbox, Tooltip } from "antd";

const Checkbox = ({
  fill,
  style,
  onBlur,
  tooltip,
  checked,
  onFocus,
  disabled,
  onChange,
  children,
  autoFocus,
  className,
  indeterminate,
  defaultChecked,
  size = "small",
}) => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const tooltipWrapper = (content) =>
    !!tooltip ? <Tooltip {...(tooltip || {})}>{content}</Tooltip> : content;

  return (
    <div
      style={style}
      className={`customCheckbox ${className} ${size}
      ${fill ? fill : isDarkMode ? "dark" : "white"}`}
    >
      {tooltipWrapper(
        <AntdCheckbox
          {...{
            onBlur,
            checked,
            onFocus,
            disabled,
            onChange,
            autoFocus,
            indeterminate,
            defaultChecked,
          }}
        >
          {children}
        </AntdCheckbox>
      )}
    </div>
  );
};

export default Checkbox;
